// @flow
import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import { hot } from 'react-hot-loader/root'
import './styles.scss'
import { LifeStep } from 'components/lifestep'
import { Tracking, Image } from 'components/contentbricks'

import { ArticleTeasers } from '@ta-interaktiv/react-article-teasers'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'

// TODO Set the correct article ID here
const ARTICLE_ID = '26654297'

function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} additionalShares={1077} />
      <ThemeSwitch />

      <header className='ui vertical very relaxed segment'>
        <div className='ui container'>
          <h1 className='ui image header'>
            <div className='content'>
              Ein Leben lang trächtig
              <br />
              und am Ende eine&nbsp;&nbsp;
              <img
                src={require('images/wurst.png')}
                width='180px'
                aria-label='Wurst'
                style={{ display: 'inline-block', verticalAlign: 'text-top' }}
              />
              <div className='sub header lead'>
                Von der Geburt bis zum Tod: das typische Leben einer Milchkuh in
                der Schweiz.
              </div>
            </div>
          </h1>
        </div>
      </header>

      <LifeStep
        title=''
        image='main_illu_1.svg'
        time='Geburt'
        text='step1.mdx'
        cssClass='first'
      />

      <LifeStep
        title=''
        image='main_illu_2.svg'
        time='Die ersten Tage'
        text='step2.mdx'
      />
      <LifeStep
        title=''
        image='main_illu_3.svg'
        time='Nach 3 Wochen'
        text='step2.5.mdx'
      />
      <Tracking label='content25' />

      <LifeStep
        title=''
        time='Nach 6 Monaten'
        image='main_illu_5.svg'
        text='step3.mdx'
      />

      <LifeStep
        title=''
        image='main_illu_4.svg'
        time='Nach 7 Monaten'
        text='step4.mdx'
      />
      <Tracking label='content50' />
      <LifeStep
        title=''
        time='Nach 1,5 Jahren'
        image='main_illu_7.svg'
        text='step5.mdx'
      />
      <LifeStep
        title=''
        time='Nach 2,5 Jahren'
        image='main_illu_9.svg'
        text='step6.mdx'
      />
      <Tracking label='content75' />

      <LifeStep
        title=''
        image='main_illu_8.svg'
        time='Nach 3,5 Jahren'
        text='step7.mdx'
      />
      <LifeStep
        title=''
        image='main_illu_11.svg'
        time='Nach 4,5 Jahren'
        text='step8.mdx'
      />

      <LifeStep
        title=''
        time='Nach 5 Jahren'
        image='main_illu_12.svg'
        text='step9.mdx'
        cssClass='last'
      />
      <div className='ui vertical segment schlachthof'>
        <div className='ui container' style={{ textAlign: 'center' }}>
          <Image
            file={[
              require('images/schlachthof-01.svg'),
              require('images/schlachthof-02.svg')
            ]}
            title=''
            subtitle=' '
          />
        </div>
      </div>

      <Footer
        articleId={ARTICLE_ID}
        credits={[
          [
            'Konzept, Illustration und Umsetzung',
            'Sebastian Broschinski und Marc Brupbacher'
          ],
          ['Text und Recherche', 'Catherine Boss und Sven Cornehls'],
          [
            'Quellen',
            'Agrarbericht 2018, BLV, BLW, European Commision, KAGfreiland, Land schafft Leben, Der Landbote, Muttterkuh Schweiz, myclimate, Proviande, Schweizer Bauer, Schweizer Kälbermäster-Verband (SKMV), SRF, Swissinfo, Swissmilk, Swissveg, Tages-Anzeiger, TVD Tierverkehrsdatenbank Identitas AG, US Department of Agriculture,  WBF'
          ]
        ]}
      >
        {/* Agrarbericht 2018 agrarbericht.ch
BLV blv.admin.ch
BLW blw.admin.ch
European Commision ec.europa.eu
KAGfreiland kagfreiland.ch
Land schafft Leben landschaftleben.at
Der Landbote landbote.ch
Muttterkuh Schweiz mutterkuh.ch
myclimate myclimate.org
Proviande proviande.ch
Schweizer Bauer schweizerbauer.ch
Schweizer Kälbermäster-Verband (SKMV) kaelbermaester.ch
SRF srf.ch
Swissinfo swissinfo.ch
Swissmilk swissmilk.ch
Swissveg swissveg.ch
Tages-Anzeiger tagesanzeiger.ch
TVD Tierverkehrsdatenbank Identitas AG identitas.ch
US Department of Agriculture ers.usda.gov
WBF wbf.admin.ch */}

        <div className='ui vertical segment'>
          <div className='ui container'>
            <ArticleTeasers
              articleIds={[
                '12827795',
                '17687029',
                '20647149',
                '25753875',
                '16595684',
                '19918846'
              ]}
              numberOfCards='three'
            />
          </div>
        </div>
      </Footer>
    </div>
  )
}

export default hot(AppComponent)
